module.exports = __webpack_public_path__ + "media/switcherIn.8bdc3538.mp3";